<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { api } from 'src/plugins/axios'
import { notify } from 'src/plugins/notify'
import creditCard from 'vue-credit-card'
import AwesomeMask from 'awesome-mask'
import UserAutoComplete from '../User/UserAutoComplete'
import {
  required,
  requiredUnless,
  email,
  minLength,
  maxLength,
  numeric,
  sameAs
} from "vuelidate/lib/validators";
const moment = require('moment')

export default {
    name: 'processPaymentModal',
    components: {
        creditCard,
        UserAutoComplete
    },
    directives: {
        'mask': AwesomeMask
    },
    async created () {
        var vm = this
        console.log('procesing class',vm.processingClass)
        if(!vm.processingClass) await vm.fetchAffiliateOrderTypeOverrides(vm.$user.USER_ID)
        if(!vm.processingClass) await vm.fetchOrderTypes()
        /**
         * Dont need to run this if it was payLater, we need to not verify the order types because it
         * could be an order type this user doesnt typically have access to, but needs to pay for.
         */
        if(!vm.pendingPayment.wasPayLater){
            _.map(vm.pendingPayment.items, (i,index) => {
                vm.updateItemFromType({itemIndex:index, orderType:i.orderType})
            })
        }
        vm.getCustomerPaymentProfiles({USER_ID: vm.currentUser().USER_ID})
    },
    validations () {
        let vm = this
        return {
            pendingPayment: {
                items: {
                    $each: {
                        orderType: { required },
                        price: { },
                        quantity: { required }
                    }
                },
                customer: {
                    USER_ID: { required }
                },
                billingAddress:{
                    address1: { required },
                    city: { required },
                    state: { required },
                    zip: { required }
                },
                mailingAddress: {
                    address1: { required: requiredUnless(() => { return vm.pendingPayment.sameAsBilling}) },
                    city:     { required: requiredUnless(() => { return vm.pendingPayment.sameAsBilling}) },
                    state:    { required: requiredUnless(() => { return vm.pendingPayment.sameAsBilling}) },
                    zip:      { required: requiredUnless(() => { return vm.pendingPayment.sameAsBilling}) }
                },
                cc: {
                    number: { minLength: minLength(17), required: requiredUnless(() => { return vm.pendingPayment.paymentType == "Paypal" || vm.pendingPayment.paymentType == "ACH"}) },
                    name:   { required: requiredUnless(() => { return vm.pendingPayment.paymentType == "Paypal" || vm.pendingPayment.paymentType == "ACH"}) },
                    expiry: { minLength: minLength(5), required: requiredUnless(() => { return vm.pendingPayment.paymentType == "Paypal" || vm.pendingPayment.paymentType == "ACH"}) },
                    cvc:    { minLength: minLength(3), required: requiredUnless(() => { return vm.pendingPayment.paymentType == "Paypal" || vm.pendingPayment.paymentType == "ACH"}) }
                },
                ach:{
                    routing: { required, minLength: minLength(9), maxLength: maxLength(9) },
                    account: { required, minLength: minLength(6), maxLength: maxLength(17) },
                    name: { required }
                },
                moneyOrder:{
                    notes: { required }
                },
                accountCredits:{
                    affiliate: { required }
                }
            }
        }
    },
    data () {
        return { 
            currentStep: 'first',
            maximized: false,
            removeDialogOptions: {
                title: 'Remove Order Item?',
                message: 'Are you sure you want to remove this item?',
                ok: {
                    label: 'Remove',
                    color: 'negative'
                },
                cancel: {
                    label: 'Cancel'
                }
            },
            moment: moment
        }
    },
    computed: {
        ...mapGetters('orders', [
            'orderTypeOptions'
        ]),
        ...mapGetters([
            'stateOptions'
        ]),
        ...mapState('orders', {
            'pendingPayment' : s => s.pendingPayment,
            'processing' : s => s.pendingPayment.processing,
            'cardDetail' : s => s.pendingPayment.cc,
            'processPaymentModalOpen' : s => s.processPaymentModalOpen,
            'authorizingBypass' : s => s.pendingPayment.adminBypass.authorizing,
            'madeAuthorizeBypassCall' : s => s.pendingPayment.adminBypass.madeCall,
            'bypassAuthorized' : s => s.pendingPayment.adminBypass.authorized,
            'closeModalOnPaymentComplete': s => s.closeModalOnPaymentComplete,
            'canAdd': s => s.pendingPayment.canAdd,
            'overrideTotal': s => s.pendingPayment.adminBypass.overrideTotal,
            'loadOrderTypes': s => s.pendingPayment.loadOrderTypes
        }),
        ...mapState('classes',{
            'processingClass' : s => s.processingClass
        }),
        ...mapState('auth', {
            'user' : s => s.user
        }),
        placeOrderText(){
            let vm = this
            return (vm.pendingPayment.wasPayLater) ? `Pay For Existing Order (#${vm.pendingPayment.ORDER_ID})` : 'Place an Order'
            
        },
        remainingCredits(){
            let vm = this
            return parseFloat(parseFloat(vm.pendingPayment.accountCredits.affiliate.value.availableCredits).toFixed(2) - parseFloat(vm.finalTotal).toFixed(2)).toFixed(2)
        },
        // shippingTotal () {
        //     return _.sumBy(vm.pendingPayment.items, (o) => {
        //         return parseFloat(vm.shippingPrice(o))
        //     }).toFixed(2)
        // },
        orderTotal () {
            let vm = this
            return _.sumBy(vm.pendingPayment.items, (o) => {
                return parseFloat(vm.itemPrice(o))
            }).toFixed(2)
        },
        hasEnoughCredits(){
            let vm = this,
                availableCredits = parseFloat(vm.pendingPayment.accountCredits.affiliate.value.availableCredits).toFixed(2),
                finalTotal = parseFloat(vm.finalTotal).toFixed(2),
                hasEnoughCredits = parseFloat(availableCredits) >= parseFloat(finalTotal)

                console.log(availableCredits >= finalTotal, typeof availableCredits, typeof finalTotal)
            return hasEnoughCredits
        },
        finalTotal () {
            let vm = this
            let total
            if(vm.pendingPayment.adminBypass.authorized){
                if(vm.bypassAuthorized) {
                    return vm.overrideTotal
                }
            }
            return vm.orderTotal
        },
        orderTotalItems () {
            let vm = this
            return _.sumBy(vm.pendingPayment.items, (o) => {
                return parseInt(o.quantity) || 0
            })
        },
        showOptions() {
            let vm = this,
                existingOrNew = vm.pendingPayment.existingOrNew
            return (vm.pendingPayment.paymentType === null || existingOrNew == 'existing') && !vm.pendingPayment.adminBypass.active && existingOrNew != 'later'
        }
    },
    methods: {
        ...mapMutations('orders',[
            'updateItemShippingMethod',
            'updateItemShippingMethodOptions',
            'updateItemFromType',
            'updateItemShippingTotal',
            'setPaymentType',
            'addPendingOrderItem',
            'paymentModalOpenState',
            'removeOrderItem',
            'updateAdminOverrideAmount',
            'autocompleteOrderAddressUpdate',
            'clearCurrentCustomerProfile',
            'setExistingOrNew',
            'setProcessing',
            'preAdminBypass',
            'selectOrderItemAffiliate',
            'selectAccountCreditsAffiliate'
        ]),
        ...mapMutations('classes', {
            'setClassProcessing' : 'setProcessing'
        }),
        ...mapActions('users',['fetchAffiliateAutoComplete']),
        ...mapActions('orders', [
            'updateItemAndShipping',
            'processOrder',
            'fetchOrderTypes',
            'fetchAffiliateOrderTypeOverrides',
            'fetchShippingMethods',
            'updateItemQuantity',
            'authorizeBypass',
            'fetch',
            'getCustomerPaymentProfiles'
        ]),
        async onSearchAffiliate (s, done) {
            let affiliates = await this.$store.dispatch('classes/affiliateAutocomplete', { search: s })
            console.log(affiliates)
            affiliates = _.map(affiliates, x => {
                x = x.item
                let a = {
                    label: `${x.AFFILIATE_NAME} - ($${x.AVAILABLE_CREDITS} Available)`,
                    name: x.AFFILIATE_NAME,
                    availableCredits: x.AVAILABLE_CREDITS,
                    value: x.AFFILIATE_ID
                }
                return {
                    ...a,
                    value: a
                }
            })
            done(affiliates)
        },
        onPayLater(){
            let vm = this
            vm.preAdminBypass({ 
                active: true,
                callback:() => {
                    vm.setExistingOrNew('later')                    
                }
            })
        },
        onPayLaterFinalize(){
            this.validateAndPay({ payLater: true })
        },
        onAddPendingOrderItem(){
            let vm = this
            vm.addPendingOrderItem()
            vm.$nextTick(() => {
                vm.$v.$reset()
                vm.$forceUpdate()
            })
        },
        onSelectAffiliate({ itemIndex, affiliate }){
            this.selectOrderItemAffiliate({ itemIndex, affiliate })
            this.$forceUpdate()
        },
        onMoneyOrder() {
            let vm = this
            vm.preAdminBypass({ 
                active: true,
                callback:() => {
                    vm.setPaymentType('Money Order')
                }
            })
        },
        onACHPayment() {
            let vm = this
            vm.preAdminBypass({ 
                active: true,
                callback:() => {
                    vm.setPaymentType('ACH Payment')
                }
            })
        },
        onUseCredits(){
            this.setPaymentType('Account Credits')
        },
        cc () {
            let component = this
            return {
                blur (ref) {
                    component.$refs[ref].classList.remove("q-if-focused")
                },
                focus (ref) {
                    component.$refs[ref].classList.add("q-if-focused")
                },

            }
        },
        itemTotal(item) {
            return parseFloat(item.shippingTotal + (item.quantity * parseFloat((item.price || 0)))).toFixed(2)
        },
        itemPrice (item) {
            return parseFloat(item.price * item.quantity + item.shippingTotal).toFixed(2)
        }, 
        hasError(itemIndex) {
            let vm = this, 
                validation = vm.$v.pendingPayment.items.$each[itemIndex],
                item = vm.pendingPayment.items[itemIndex],
                hasAffiliateError = item.orderType == 76 ? item.affiliate == null : false
            return validation.$error || (hasAffiliateError && validation.$dirty)
        },    
        async validateAndPay ({ payLater = false } = { payLater: false }) {
            let vm = this
            vm.setProcessing(true)
            let validated = vm.canSubmitPayment()
            if(validated){
                vm.processOrder({user: vm.user, total: vm.finalTotal, payLater })
                    .then(res=>{
                        if(res.data.success){
                            if(vm.closeModalOnPaymentComplete){
                                vm.paymentModalOpenState(false)
                            }
                            if(vm.processPaymentCallback){
                                vm.processPaymentCallback.call()
                            }
                            notify.create({ message: "Successfully processed Order", type: 'positive' })
                            // Refresh Grid
                            vm.$root.$emit('refreshGrid:ordersGrid')
                        }
                        else{
                            notify.create({ message: res.data.message, type: 'negative' })
                        }
                        vm.setProcessing(false)
                    })
                    .catch(err => {
                        vm.setProcessing(false)
                    })
            }
            else{
                vm.setProcessing(false)
                if(vm.pendingPayment.paymentType){
                    notify.create({message: "Please fix all errors.", type: 'negative'})
                }
            }
        },
        toggleMaximized () {
            this.maximized = !this.maximized
        },
        canSubmitPayment() {
            let vm = this
            let paymentType   = vm.pendingPayment.paymentType,
                existingOrNew = vm.pendingPayment.existingOrNew,
                isAdminBypassAuthorized = !!vm.pendingPayment.adminBypass.authorized

            vm.$v.pendingPayment.$touch()
            if(existingOrNew == 'later'){
                return isAdminBypassAuthorized
            }
            if(vm.pendingPayment.adminBypass.flag){
                return isAdminBypassAuthorized
            }
            if(paymentType === 'ACH Payment'){
                return !vm.$v.pendingPayment.ach.$invalid
            }
            if(paymentType === 'Money Order'){
                return !vm.$v.pendingPayment.moneyOrder.$invalid
            }
            if(paymentType === 'Account Credits'){
                let validAffiliate = vm.pendingPayment.accountCredits.affiliate
                return !vm.$v.pendingPayment.accountCredits.$invalid && validAffiliate && vm.hasEnoughCredits
            }
            if(paymentType === 'Credit Card' && existingOrNew == 'new'){
                return !vm.$v.pendingPayment.cc.$invalid && vm.$refs['credit-card'].classDisplay.expiry['jp-card-valid']
            }
            let noExistingProfile = vm.pendingPayment.existingOrNew === 'existing' && !vm.pendingPayment.customer.selectedPaymentProfile
            if(!paymentType || noExistingProfile){
                notify.create({message:"Please select a Payment Method.", type: "negative"})
                return false
            }
            if(existingOrNew === 'existing' && vm.pendingPayment.customer.selectedPaymentProfile){
                return true
            }
            return false//true
        },
        selectUser (val){
            this.getCustomerPaymentProfiles(val.item)
        },
        proceedToBilling() {
            let vm = this
            if(vm.pendingPayment.items.length == 0){
                return notify.create({
                    message: 'Please add an item!',
                    type: 'negative'
                })
            }

            vm.$v.pendingPayment.items.$each.$touch()
            let hasInvalidAffiliates = vm.pendingPayment.items.filter(x => {
                return x.orderType == 76 && x.affiliate === null
            }).length
            if(!vm.$v.pendingPayment.items.$each.$invalid && !hasInvalidAffiliates) vm.$refs.stepper.next()
        },
        proceedToPayment() {
            let vm = this,
                billingAddress = vm.$v.pendingPayment.billingAddress,
                mailingAddress = vm.$v.pendingPayment.mailingAddress,
                customer       = vm.$v.pendingPayment.customer
                
            billingAddress.$touch()
            mailingAddress.$touch()
            customer.$touch()

            if(!billingAddress.$invalid && !mailingAddress.$invalid && !customer.$invalid) vm.$refs.stepper.next()
        },
        canEditItem(item) {
            let canEdit = item.canEdit === true || item.canEdit === undefined
            return canEdit
        },
        disableShippingMethod (item) {
            let canEdit = !this.canEditItem(item) 
            let hasOrderType = !!item.orderType
            
            return canEdit && hasOrderType
        },
        onRemoveOrderItem(orderItem) {
            let vm = this
            vm.$q.dialog(this.removeDialogOptions)
            .then(() => {
                vm.removeOrderItem(orderItem)
            })
            .catch(err => {})
        },
        onDropdownFocus (index) {
            let dropdown = this.$refs[index]
            dropdown.show()
        },
        quantityBetweenHelper(item) {
            let label
            if(!item.min && item.max){
                label = 'Max ' + item.max
            }
            else if( !item.max && item.min){
                label = 'Minimum ' + item.min
            }
            else if( item.max === item.min && item.max != null ){
                label = 'Only ' + item.max
            }
            else if( item.max && item.min){
                label = 'Between ' + item.min + ' and ' + item.max
            }
            else {
                label = 'Max 1'
            }

            return label
        },
        placeChange(place, field) {
            this.autocompleteOrderAddressUpdate({
                place,
                field,
                stateOptions: this.stateOptions
            })
        }
    }
}
</script>

<template>
    <q-modal
    id="processPayment"
        class="sl-modal"
        :value="processPaymentModalOpen"
        :no-esc-dismiss="true"
        :no-backdrop-dismiss="true"
        :maximized="maximized"
        :content-css="{width: '1300px', height: '800px'}">
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-toolbar-title>
                    <q-icon name="attach_money" /> {{placeOrderText}}
                </q-toolbar-title>
                <q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none" />
                <q-icon @click.native="paymentModalOpenState(false)" name="clear" />
            </q-toolbar>
            <q-stepper color="primary" ref="stepper" alternative-labels v-model="currentStep">
                <q-step default name="first" active-icon="fa fa-shopping-cart" title="Order Details" style="background:#f4f4f4" class="no-padding" :class="{'active': currentStep == 'first'}">
                    <div class="order-details">
                        <!-- <div class="sl-row item-row">
                            <div class="sl-col-1 no-padding text-center text-weight-medium">
                                &nbsp;
                            </div> -->
                            <!-- <div class="sl-col-5 text-weight-medium">
                                Item Name
                            </div>
                            <div class="sl-col-2 text-weight-medium">
                                Quantity
                            </div>
                            <div class="sl-col-2 price text-weight-medium">
                                Unit Price
                            </div>
                            <div class="sl-col-2 text-weight-medium">
                                Total
                            </div>
                            <div class="sl-col-1 no-padding text-weight-medium" v-show="canAdd">
                                Remove
                            </div>
                        </div> -->
                        <div class="sl-row item-row" v-for="(item,i) in pendingPayment.items" :key="i" :class="{ 'error' : hasError(i) }">
                            <div class="sl-row">
                                <div class="sl-col-3 text-weight-bolder">
                                    <q-field 
                                        :error="$v.pendingPayment.items.$each[i].orderType.$error"
                                        error-label="Please select an Order Type!">
                                        <q-select
                                            float-label="Order Type"
                                            :value="item.orderType"
                                            :options="orderTypeOptions"
                                            @change="val => updateItemAndShipping({ itemIndex: i, orderTypeId: val })"
                                            :disable="!canEditItem(item) || !canAdd"
                                        />
                                    </q-field>
                                    <q-btn color="positive" v-if="item.affiliate" @click="onSelectAffiliate({ itemIndex: i, affiliate: null })">
                                        <q-icon name="fa fa-building" size="17px" class="q-mr-sm" /> {{item.affiliate.name}}
                                        <q-icon name="fa fa-close" size="17px" class="q-ml-sm" />
                                    </q-btn>
                                    <q-field 
                                        v-if="item.orderType === 76 && !item.affiliate"
                                        :error="$v.pendingPayment.items.$each[i].$dirty && item.affiliate == null"
                                        error-label="Which Affiliate should recieve the credits?">
                                        <q-search :value="item.affiliate" placeholder="Search Affiliates" >
                                            <q-autocomplete
                                                :debounce="500"
                                                :max-results="10"
                                                @search="onSearchAffiliate"
                                                @selected="affiliate => onSelectAffiliate({ itemIndex: i, affiliate })"
                                            />
                                        </q-search>
                                    </q-field>
                                </div>
                                <div class="sl-col-1half price price-each">
                                    <q-input float-label="Price Each" hide-underline prefix="$" :disable="true" type="number" :value="(item.price || 0)" />
                                </div>
                                <div class="sl-col-1half no-padding">
                                    <q-field :helper="quantityBetweenHelper(item)">
                                        <q-input
                                            prefix="×"
                                            type="number"
                                            float-label="Quantity"
                                            :decimals="0"
                                            @input="val => { updateItemFromType({itemIndex: i, orderType: item.orderType, quantity: val}); updateItemShippingTotal({itemIndex: i}); }"
                                            :min="item.min || 1"
                                            :max="item.max || 1"
                                            :disable="!canAdd || !canEditItem(item) || (!item.min && !item.max)"
                                            :value="(item.quantity || 1)" />                                        
                                    </q-field>
                                </div>
                                <div class="sl-col-1 no-padding">
                                    <q-btn
                                        @click="onRemoveOrderItem(i)"
                                        v-if="canEditItem(item) && canAdd"
                                        color="red"
                                        outline
                                        flat
                                        icon="delete outline">
                                        <q-tooltip>Remove Item</q-tooltip>
                                    </q-btn>
                                </div>
                                <div class="sl-col-3 no-padding-left text-weight-bolder">
                                    <q-select
                                        float-label="Shipping Method"
                                        :value="item.shippingMethod"
                                        :options="item.shippingMethodOptions"
                                        @change="val => updateItemShippingMethod({ itemIndex: i, shippingMethod: val })"
                                        :disable="!canEditItem(item) || !item.orderType"
                                        v-if="item.shippingMethodOptions.length > 0"
                                    />
                                </div>
                                <div class="sl-col-1 no-padding">
                                    <q-input float-label="Shipping Total" hide-underline prefix="$" :disable="true" type="number" :value="item.shippingTotal" v-if="item.shippingMethodOptions.length > 0 && item.shippingTotal >= 0"/>
                                </div>
                                <div class="sl-col-1 no-padding text-weight-bolder item-total" style="float:right">
                                    <q-input float-label="Total" hide-underline prefix="$" :disable="true" type="number" :value="itemTotal(item)" />
                                </div> 
                            </div>         
                        </div>
                        <div class="row">
                            <q-btn style="margin:10px 25px" v-if="canAdd" color="primary" icon="add" @click="onAddPendingOrderItem()" outline label="Add Item" />
                            <div style="flex-grow:1"></div>
                            
                            <span class="order-total order-details-tab">Order Total: <b>${{finalTotal}} </b><span v-if="pendingPayment.adminBypass.authorized">&nbsp;(Admin Override)</span></span>
                        </div>
                    </div>
                </q-step>
                <q-step name="second" title="Billing Information" active-icon="fa fa-usd" :class="{'active': currentStep == 'second'}">                    
                    <div class="sl-row">
                        <div class="sl-col-12">
                            <h5><q-icon name="fa fa-info" color="primary" /> Payer Information</h5>
                        </div>
                        <div class="sl-col-6" style="padding-top:12px">
                            <user-auto-complete 
                                :error="$v.pendingPayment.customer.USER_ID.$error"
                                :onSelect="selectUser"
                                :userId="pendingPayment.customer.USER_ID"
                                :disable="!$p(['ADMIN','MANAGER'],'or')"
                                v-if="!pendingPayment.customer.USER_ID"
                            />
                            <div class="text-bold user-info" v-if="pendingPayment.customer.user.USER_FIRST_NAME">
                                <q-icon name="account_box" color="primary" size="20px" /> {{pendingPayment.customer.user.USER_FIRST_NAME}} {{pendingPayment.customer.user.USER_LAST_NAME}} <q-btn icon="fa fa-trash" round flat color="red" v-if="$p(['ADMIN','MANAGER'],'or')" @click.native="clearCurrentCustomerProfile()" />
                            </div>
                        </div>
                        <div class="sl-col-6">
                            <q-input float-label="Phone" v-model="pendingPayment.customer.user.USER_PHONE" :before="[{icon:'phone'}]" />
                        </div>
                    </div>
                    <div class="sl-row">
                        <div class="sl-col-6">
                            <h5><q-icon name="location_on" color="primary" /> Billing Address</h5>
                            <div class="row">
                                <q-field class="col-12"
                                :error="$v.pendingPayment.billingAddress.address1.$error"
                                error-label="Address required">
                                    <q-input
                                    float-label="Address 1"
                                    v-model="pendingPayment.billingAddress.address1"
                                    v-places-autocomplete="(place) => placeChange(place, 'billingAddress')"/>
                                </q-field>
                            </div>
                            <div class="row">
                                <q-field class="col-8"
                                :error="$v.pendingPayment.billingAddress.city.$error"
                                error-label="City required">
                                    <q-input float-label="City" v-model="pendingPayment.billingAddress.city" />
                                </q-field>
                                <q-field class="col-4"
                                :error="$v.pendingPayment.billingAddress.state.$error"
                                error-label="State required">
                                    <q-select
                                        float-label="State"
                                        :ref="'billingStateDropdown'"
                                        :options="stateOptions" v-model="pendingPayment.billingAddress.state"
                                        @focus="onDropdownFocus('billingStateDropdown')" filter autofocus-filter
                                     />
                                </q-field>
                            </div>
                            <div class="row">
                                <q-field class="col-6"
                                :error="$v.pendingPayment.billingAddress.zip.$error"
                                error-label="Zip Required">
                                    <q-input float-label="Zip" v-model="pendingPayment.billingAddress.zip" />
                                </q-field>
                                <q-field class=" col-6" >
                                    <q-input float-label="County" v-model="pendingPayment.billingAddress.county" />
                                </q-field>
                            </div>
                        </div>
                        <div class="sl-col-6">
                            <h5><q-icon name="local_shipping" color="primary" /> Mailing Address <q-checkbox style="margin-left:20px" v-model="pendingPayment.sameAsBilling"/> <span>Same as Billing</span></h5>
                            <div v-show="!pendingPayment.sameAsBilling">
                                <div class="row"> 
                                    <q-field class="col-12"
                                    :error="$v.pendingPayment.mailingAddress.address1.$error"
                                    error-label="Address required">
                                        <q-input
                                        float-label="Address 1"
                                        v-model="pendingPayment.mailingAddress.address1"
                                        v-places-autocomplete="(place) => placeChange(place, 'mailingAddress')"/>
                                    </q-field>
                                </div>
                                <div class="row">
                                    <q-field class="col-8"
                                    :error="$v.pendingPayment.mailingAddress.city.$error"
                                    error-label="City required">
                                        <q-input float-label="City"  v-model="pendingPayment.mailingAddress.city" />
                                    </q-field>
                                    <q-field class="col-4"
                                    :error="$v.pendingPayment.mailingAddress.state.$error"
                                    error-label="State required">
                                        <q-select
                                            float-label="State"
                                            :ref="'shippingStateDropdown'"
                                            :options="stateOptions" v-model="pendingPayment.mailingAddress.state"
                                            @focus="onDropdownFocus('shippingStateDropdown')" filter autofocus-filter
                                        />
                                    </q-field>
                                </div>
                                <div class="row">
                                    <q-field class="col-6"
                                    :error="$v.pendingPayment.mailingAddress.zip.$error"
                                    error-label="Zip Required">
                                        <q-input float-label="Zip" v-model="pendingPayment.mailingAddress.zip">
                                    </q-input>
                                    </q-field>
                                    <q-field class="col-6">
                                        <q-input float-label="County" v-model="pendingPayment.mailingAddress.county" />
                                    </q-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </q-step>
                <q-step name="third" title="Finalize Payment" active-icon="fa fa-check" class="finalize" :class="{'active': currentStep == 'third'}">
                    <div class="row">
                        <div class="col-5 payment-method-left">
                            <!-- Authorize Bypass CTA / Badge -->
                            <div class="bypass" v-if="pendingPayment.paymentType != null && $p(['ADMIN'])">
                                <span class="authorized-badge" v-if="pendingPayment.adminBypass.authorized">
                                    <q-icon name="check" />
                                    Authorized
                                </span>
                                <q-btn
                                    class="bypass-btn"
                                    color="grey-7"
                                    round outline
                                    v-show="!pendingPayment.adminBypass.active || !pendingPayment.adminBypass.authorized"
                                    @click.native="preAdminBypass({ active: true })"
                                    icon="fa fa-key" />
                            </div>
                            
                            <!-- Admin Bypass -->
                            <div v-if="pendingPayment.adminBypass.active == true && $p(['ADMIN'])">
                                <q-btn color="secondary"
                                    icon="fa fa-arrow-left"
                                    @click="preAdminBypass({ active: false })"
                                    flat label="Back" />
                                <div class="admin-bypass">
                                    <form @submit.prevent="authorizeBypass()">
                                        <q-input
                                            float-label="Confirm Admin Password"
                                            type="password"
                                            :disable="authorizingBypass"
                                            v-model="pendingPayment.adminBypass.password" />
                                        <div class="text-right">
                                            <q-btn color="green" icon="vpn key" label="Authorize" type="submit" :loading="authorizingBypass" />
                                            <div class="authorize-helper" v-if="madeAuthorizeBypassCall">
                                                <span class="text-red"   v-if="!bypassAuthorized"><q-icon name="error_outline" /> Error Authenticating</span>
                                                <span class="text-green" v-if="bypassAuthorized"><q-icon name="check" /> Successfully Authorized</span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <!-- Back Button -->
                            <q-btn color="secondary" v-if="(showOptions && pendingPayment.existingOrNew) || pendingPayment.existingOrNew == 'later'" class="options-back" icon="fa fa-arrow-left" @click="setExistingOrNew(null);setPaymentType(null)" flat label="Back" />

                            <!-- Pay Later -->
                            <div v-if="!pendingPayment.adminBypass.active && pendingPayment.existingOrNew == 'later'">
                               <p class="q-pt-lg q-pb-sm">This order will still be processed but marked as <b>Unpaid</b>, Continue?</p>
                               <q-btn @click="onPayLaterFinalize()" icon="send" color="positive" label="Yes, Finalize Order" /> 
                            </div>

                            <!-- Existing or New -->
                            <div class="options"
                                v-if="showOptions">
                                <div class="text-center" v-if="!pendingPayment.existingOrNew">
                                    <q-btn color="primary" style="margin-bottom: 10px" icon="credit card" @click="setExistingOrNew('existing');setPaymentType('Credit Card')" label="Existing Payment Methods" v-if="pendingPayment.customer.paymentProfiles && pendingPayment.customer.paymentProfiles.length > 0" />
                                    <div><q-btn color="green" icon="add" @click="setExistingOrNew('new')" label="New Payment Method" /></div>
                                    <div v-if="$p(['ADMIN']) && !pendingPayment.wasPayLater" style="margin-top: 10px"><q-btn outline color="grey-8" icon="schedule_send" @click="onPayLater()" label="Pay Later" /></div>
                                </div>
                                <div v-if="pendingPayment.existingOrNew == 'existing'">
                                    <h6>Use Existing Method:</h6>
                                    <q-select 
                                        :options="pendingPayment.customer.paymentProfiles"
                                        placeholder="Select Method"
                                        v-model="pendingPayment.customer.selectedPaymentProfile"
                                        float-label
                                        :before="[{icon:'credit card'}]" />
                                </div>
                                <div class="text-center" v-if="pendingPayment.existingOrNew == 'new'">
                                    <h6>Select New Method:</h6>
                                    <div><q-btn style="margin-bottom:10px" color="primary" icon="credit card" outline @click="setPaymentType('Credit Card')" label="Credit Card" /></div>
                                    <div v-if="$p(['ADMIN'])"><q-btn style="margin-bottom:10px;" color="grey-7" icon="fa fa-bank" outline @click="onACHPayment()" label="ACH Payment" /></div>
                                    <div v-if="$p(['ADMIN'])"><q-btn style="margin-bottom:10px;" color="green-7" icon="fa fa-money" outline @click="onMoneyOrder()" label="Money Order" /></div>
                                    <div v-if="!_.some(pendingPayment.items, x => x.orderType == 76)"><q-btn style="margin-bottom:10px;" color="green-7" icon="fa fa-usd" outline @click="onUseCredits()" label="Account Credits" /></div>
                                    <div><q-btn style="margin-bottom:10px; opacity:0.2 !important" :disable="true" color="green" icon="fa fa-paypal" outline @click="setPaymentType('Paypal')" label="Paypal" /></div>
                                </div>
                            </div>

                            <!-- New Payment Methods -->
                            <div v-if="pendingPayment.paymentType != null  && !pendingPayment.adminBypass.active && pendingPayment.existingOrNew == 'new'">
                                <q-btn color="secondary"
                                    icon="fa fa-arrow-left"
                                    style="margin-bottom:20px;"
                                    @click="setPaymentType(null)"
                                    flat label="Back" />
                                <div class="money-order" v-show="pendingPayment.paymentType === 'Money Order'">
                                    <div class="q-mr-lg">
                                        <h6>Money Order</h6>
                                        <q-field class="col-12"
                                            :error="$v.pendingPayment.moneyOrder.notes.$invalid"
                                            error-label="Money Order Notes required!">
                                            <q-input type="textarea" stack-label="Notes" v-model="pendingPayment.moneyOrder.notes" />
                                        </q-field>
                                    </div>
                                </div>
                                <div class="account-credits" v-show="pendingPayment.paymentType === 'Account Credits'">
                                    <div class="q-mr-lg">
                                        <h6>Use Account Credits</h6>
                                        <p class="text-caption" v-if="pendingPayment.accountCredits.affiliate == null">Please select an Affiliate with available Credits. </p>
                                        <div class="q-mt-md" v-else>
                                            <div><b>Seleted Affiliate</b></div>
                                            <q-btn color="positive" class="q-mt-sm q-mb-sm" @click="selectAccountCreditsAffiliate(null)">                                            
                                                <q-icon name="fa fa-building" size="17px" class="q-mr-sm" /> {{pendingPayment.accountCredits.affiliate.name}}
                                                <q-icon name="fa fa-close" size="17px" class="q-ml-sm" />
                                            </q-btn>
                                            <div :class="{'text-red': !hasEnoughCredits}"><b>Credits Available: ${{pendingPayment.accountCredits.affiliate.value.availableCredits}}</b></div>
                                        </div>
                                        <q-field
                                            :error="$v.pendingPayment.accountCredits.affiliate.$error"
                                            error-label="Please select a valid Affiliate."
                                            v-if="pendingPayment.accountCredits.affiliate == null">
                                            <q-search :value="pendingPayment.accountCredits.affiliate" placeholder="Search Affiliates" >
                                                <q-autocomplete
                                                    :debounce="500"
                                                    :max-results="10"
                                                    @search="onSearchAffiliate"
                                                    @selected="affiliate => selectAccountCreditsAffiliate(affiliate)"
                                                />
                                            </q-search>
                                        </q-field>
                                    </div>
                                </div>                                
                                <div class="ach-payment" v-show="pendingPayment.paymentType === 'ACH Payment'">
                                    <div class="q-mr-lg">
                                        <h6>ACH Payment</h6>
                                        <q-field :error="$v.pendingPayment.ach.routing.$error" error-label="Routing Number must be 9 Digits">
                                            <q-input style="margin-bottom:10px" v-mask="'999999999'" float-label="Routing Number" outlined v-model="pendingPayment.ach.routing" />
                                        </q-field>
                                        <q-field :error="$v.pendingPayment.ach.account.$error" error-label="Account Number Required. 6 - 17 Digits.">
                                            <q-input style="margin-bottom:10px" v-mask="'99999999999999999'" float-label="Account Number" v-model="pendingPayment.ach.account" />
                                        </q-field>
                                        <q-field :error="$v.pendingPayment.ach.name.$error" error-label="Account Name Required">
                                            <q-input style="margin-bottom:10px" float-label="Account Name" v-model="pendingPayment.ach.name" />
                                        </q-field>
                                        <q-checkbox v-model="pendingPayment.ach.saveForLater" label="Save for Later Use" />
                                    </div>
                                </div>
                                <div class="credit-card" v-show="pendingPayment.paymentType === 'Credit Card'">
                                    <credit-card ref="credit-card" v-model="cardDetail" class="card-helper" />
                                    <div class="cc-error text-center" v-if="$v.pendingPayment.cc.$invalid">
                                        Please fill in all fields!
                                    </div>
                                    <div class="text-center" style="margin-top:10px">
                                        <q-checkbox v-model="pendingPayment.cc.saveForLater" label="Save for Later Use" />
                                    </div>
                                    <div class="cc-field-wrap">
                                        <div tabindex="-1" class="q-if q-focus row no-wrap items-end relative-position q-input text-primary" ref="number">
                                            <div class="q-if-inner col row no-wrap relative-position">
                                                <input
                                                    autocomplete="off"
                                                    placeholder="Card Number"
                                                    type="text"
                                                    name="number"
                                                    @focus="cc().focus('number')"
                                                    @blur="cc().blur('number')"
                                                    class="col q-input-target q-no-input-spinner"
                                                    v-model="cardDetail.number"
                                                    v-card-focus
                                                />
                                            </div>
                                        </div>
                                        <div tabindex="-1" class="q-if q-focus row no-wrap items-end relative-position q-input text-primary" ref="name">
                                            <div class="q-if-inner col row no-wrap relative-position">
                                                <input
                                                    autocomplete="off"
                                                    placeholder="Full Name"
                                                    type="text"
                                                    name="name"
                                                    @focus="cc().focus('name')"
                                                    @blur="cc().blur('name')"
                                                    class="col q-input-target q-no-input-spinner"
                                                    v-model="cardDetail.name"
                                                    v-card-focus
                                                />
                                            </div>
                                        </div>
                                        <div tabindex="-1" class="q-if q-focus row no-wrap items-end relative-position q-input text-primary" ref="expiry">
                                            <div class="q-if-inner col row no-wrap relative-position">
                                                <input 
                                                    autocomplete="off"
                                                    placeholder="MM/YY"
                                                    type="text"
                                                    name="expiry"
                                                    @focus="cc().focus('expiry')"
                                                    @blur="cc().blur('expiry')"
                                                    class="col q-input-target q-no-input-spinner"
                                                    v-model="cardDetail.expiry"
                                                    v-card-focus
                                                />
                                            </div>
                                        </div>
                                        <div tabindex="-1" class="q-if q-focus row no-wrap items-end relative-position q-input text-primary" ref="cvc">
                                            <div class="q-if-inner col row no-wrap relative-position">
                                                <input
                                                    autocomplete="off"
                                                    placeholder="CVC"
                                                    type="number"
                                                    name="cvc"
                                                    @focus="cc().focus('cvc')"
                                                    @blur="cc().blur('cvc')"
                                                    class="col q-input-target q-no-input-spinner"
                                                    v-model="cardDetail.cvc"
                                                    v-card-focus
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                      
                        </div>
                        <div class="col-7 review-items">
                            <div class="sl-row">
                                <div class="sl-col-5">
                                    <h5>
                                        <q-icon name="fa fa-list-alt" color="primary" /> 
                                        Order Review <q-btn icon="fa fa-edit" size="sm" round color="secondary" outline @click="$refs.stepper.goToStep('first')" />
                                    </h5>
                                </div>
                                <div class="sl-col-7 text-right">
                                    
                                </div>
                            </div>
                            <div class="sl-row item-row" v-for="(item,i) in pendingPayment.items" :key="i">
                                <div class="sl-col-4 text-weight-bolder no-padding">
                                    <q-select
                                        hide-underline 
                                        float-label="Order Type"
                                        :value="item.orderType"
                                        :options="orderTypeOptions"
                                        :disable="true"
                                    />
                                    <span class="text-positive" v-if="item.orderType == 76 && item.affiliate">For {{item.affiliate.name}}</span>
                                </div>
                                <div class="sl-col-2">                               
                                    <q-input
                                        hide-underline 
                                        prefix=""
                                        type="number"
                                        float-label="Qty."
                                        :disable="true"
                                        :value="item.quantity" />
                                </div>
                                <div class="sl-col-2 price no-padding">
                                    <q-input float-label="Unit Price" hide-underline prefix="$" :disable="true" type="number" :value="item.price" />
                                </div>
                                <div class="sl-col-2 price no-padding">
                                    <q-input float-label="Shipping" hide-underline prefix="$" :disable="true" type="number" :value="item.shippingTotal" />
                                </div>
                                <div class="sl-col-2 text-weight-bolder">
                                    <q-input float-label="Total" hide-underline prefix="$" :disable="true" type="number" :value="itemPrice(item)" />
                                </div>
                            </div>
                            <div class="sl-row">     
                                <div v-if="bypassAuthorized" id="adminBypassText" class="sl-col-12 text-right sl-vp ">
                                    <h5><small>Admin Override</small>: <q-input style="width:100px; float:right" prefix="$" @input="val => updateAdminOverrideAmount(val)" :value="overrideTotal" type="number" /></h5>
                                </div>                   
                                <div class="sl-col-12 text-right sl-vp">
                                    <h5><small>Order Total</small>: ${{finalTotal}}</h5>
                                    <div v-if="pendingPayment.paymentType === 'Account Credits' && pendingPayment.accountCredits.affiliate && pendingPayment.accountCredits.affiliate.value.availableCredits >= finalTotal">
                                        <b>Credits After Purchase: <span  :class="{'text-red': !hasEnoughCredits}">${{remainingCredits}}</span></b>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </q-step>
            </q-stepper>
            <q-toolbar slot="footer" class="sl-footer">
                <b class="order-total" @click="$refs.stepper.goToStep('first')">Order Total: ${{finalTotal}} <i>({{orderTotalItems}} Items)</i></b>
                <q-toolbar-title></q-toolbar-title>
                <q-btn color="primary" @click="proceedToBilling()" v-show="currentStep == 'first'" label="Continue" />
                <q-btn color="secondary" @click="$refs.stepper.previous()" flat v-show="currentStep != 'first'" label="Back" />
                <q-btn color="primary" @click="proceedToPayment()" v-show="(currentStep != 'first') && (currentStep != 'third')" label="Next" />
                <q-btn color="positive" @click="validateAndPay()" :loading="processing" v-show="currentStep == 'third' && pendingPayment.existingOrNew != 'later'" icon="send" label="Finalize Payment" />
                <q-btn outline color="faded" @click="paymentModalOpenState(false);setClassProcessing(false)" label="Cancel" />
            </q-toolbar>
        </q-modal-layout>
    </q-modal>
</template>

<style lang="stylus">
    @import '~variables'
    #adminBypassText
        padding-bottom: 0px;
    #processPayment
        .bypass
            position relative   
            float right
            margin-right 20px
            .authorized-badge
                vertical-align middle
                padding: 7px 50px 7px 20px;
                border-radius: 20px 0 0 20px;
                margin-right: -20px;
                background: #2dcb96;
                color: #fff;
                position: relative;
                z-index: 1;
                font-size: 14px;
                .q-icon 
                    display inline-block
            .bypass-btn
                position relative
                z-index 2
                background white !important
        .user-info
            display inline-block
            border-radius 50px
            padding 0 15px 0 20px
            border 1px solid #ddd
            line-height 40px
        .modal-content
                max-height 100%
        .sl-footer
            .q-btn
                margin-left 5px
        .cc-error
            padding 10px
            background #f44336
            color #fff !important
        .q-stepper-tab
            .q-stepper-title
                transition font-size 0.2s ease-in-out
            &.step-active 
                .q-stepper-title
                    font-size 21px
        .q-stepper
            height 100% 
            flex-direction column
            flex-wrap nowrap
            .q-stepper-step
                overflow-y auto
                overflow-x hidden
                flex-grow 1
                display none
                &.active
                    display block
                    height 100%
                &.no-padding
                    .q-stepper-step-inner
                        padding 0
                .item-row
                    padding 20px
                    border-bottom 1px solid border-color
                    margin 0
                    &.error
                        background #ffebe9
                    &:last-child
                        border-bottom none
                    .q-if-label-above
                        font-weight 600
                        color text-color
                        opacity 1
            .order-details
                margin 20px
                border 1px solid border-color
                border-radius 8px
                background #fff
                .deleted
                    text-decoration line-through
                    text-decoration-color red
            .finalize
                .q-stepper-step-inner,
                .q-stepper-step-content
                    height 100%
                    > .row
                        height 100%
        .credit-card
            .q-input
                margin-bottom 15px
            .card-helper
                margin-bottom 15px
        .jp-card
            .jp-card-front
                .jp-card-lower
                    .jp-card-number,
                    .jp-card-cvc,
                    .jp-card-name,
                    .jp-card-expiry
                        font-family 'Montserrat', sans-serif
                        font-weight 600
        .admin-bypass
            padding 100px 40px 0
            .q-btn
                margin-top 20px
            .authorize-helper
                display block
                padding-top 10px
        .order-total 
            color text-color
            cursor pointer
            &:hover
                color #000
                i
                    color #000
            i
                font-size 13px
                color #bbb
            &.order-details-tab
                font-weight bold
                float right
                padding 18px 48px 0 0
                color #B12704
                cursor default
                b
                    font-size 20px
                    position relative
                    top -2px
                    display inline-block
                    padding-left 20px
                    vertical-align middle
        h5
            span
                margin-left 5px
                font-size 12px
                vertical-align middle
        .options-back
            position relative  
            z-index 2
        .options   
            display flex
            align-items center
            flex-direction column
            justify-content center
            position absolute
            top 0
            left 0
            height 100%
            width 100%
            h6
                margin-bottom 30px
    .cc-field-wrap
        padding 20px
    .payment-method-left
        margin-top -24px
        margin-bottom -24px
        border-right 1px solid border-color
        padding-top 20px
        position relative

    .review-items
        padding-left 25px

    .item-total
        .q-input,
        .q-input-target,
        .q-if-addon,
        .q-if-label-above
            opacity 1 !important
            color #B12704 !important
        .q-input-target 
            font-size 20px
    .price-each
        .q-input,
        .q-input-target,
        .q-if-addon,
        .q-if-label-above
            opacity 1 !important
</style>
